<img class="loading-img" src="assets/images/loading-square-dots.gif">